import React from 'react';
import { bool, func } from 'prop-types';

const StyledBurger = ({ open, setOpen }) => {
  return (
    <div>
      {open ? (
        <span class="rounded-md shadow-sm">
          <button
            type="button"
            onClick={() => setOpen(!open)}
            class="inline-flex justify-center w-full rounded-md py-2 text-sm leading-5 font-medium text-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-blue active:text-gray-800 transition ease-in-out duration-150"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <svg
              class="h-8 w-13 transition ease-in-out duration-150"
              viewBox="1 -2 21 20"
              fill="white"
            >
              <path
                fill-rule="evenodd"
                d="M11.5,6.6l9-8.6L22-0.6L13,8l9,8.6L20.5,18l-9-8.6l-9,8.6L1,16.6L10,8L1-0.6L2.5-2L11.5,6.6z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </span>
      ) : (
        <span class="rounded-md shadow-sm">
          <button
            type="button"
            onClick={() => setOpen(!open)}
            class="inline-flex justify-center w-full rounded-md py-2 text-sm leading-5 font-medium text-white hover:text-gray-500 focus:outline-none focus:border-blue active:bg-blue transition ease-in-out duration-150"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <svg class="h-8 w-13" viewBox="0 0 20 16" fill="#f3bc1f">
              <path
                fill-rule="evenodd"
                d="M20,2H0V0h20V2z M20,7H0v2h20V7z M20,14H0v2h20V14z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </span>
      )}
    </div>
  );
};
StyledBurger.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired
};

export default StyledBurger;

//<BurgerStyles open={open} onClick={() => setOpen(!open)}/>
